"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EmbedRenderer = {
    renderV1(content) {
        return {
            type: "Embed",
            value: {
                oembed: content.all,
            },
        };
    },
    renderV2(_def, content) {
        return content.all;
    },
    renderDefault(_def) {
        return {};
    },
    renderMocks(def, content) {
        return this.renderV2(def, content);
    },
};
exports.default = EmbedRenderer;
